<template>
  <div class="tongjibaobiao">
    <div class="cont_service">
      <div class="cont_title">主要包含服务</div>
      <div class="s_main">
        <div class="m_left wow bounceInLeft">
          <img
            src="../../assets/img/productService/tongjibaobiao/poster.png"
            alt="统计报表代填代报"
          />
        </div>
        <div class="m_right wow bounceInRight">
          <div class="m_title">
            <div class="title_zh">统计报表代填代报</div>
            <div class="title_en">STATISTICAL REPORT FILLING AND REPORTING</div>
          </div>
          <ul class="serviceList">
            <li class="s_item">为广州市房地产企业代填代报</li>
            <li class="s_item">协助报送统计报表</li>
            <li class="s_item">办理《广州市房地产开发企业统计报表年检证》</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont_case wow bounceInUp">
      <div class="cont_title">服务案例</div>
      <div class="c_main">
        <div class="m_info">
          <p>
            近年来服务过多家大型房地产企业，如和记黄埔地产集团、广东宏信达房地产开发有限公司等。
          </p>
          <div class="caseBox">
            <div class="item_case">
              <div class="case_img">
                <img
                  src="../../assets/img/productService/tongjibaobiao/logo_gdhxd.png"
                  alt="广东宏信达房地产开发有限公司"
                />
              </div>
              <p>广东宏信达房地产开发有限公司</p>
            </div>
            <div class="item_case">
              <div class="case_img">
                <img
                  src="../../assets/img/productService/tongjibaobiao/logo_hjhp.png"
                  alt="和记黄埔地产集团"
                />
              </div>
              <p>和记黄埔地产集团</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tongjibaobiao",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.tongjibaobiao {
  .cont_title {
    font-size: 18px;
    color: #333333;
    padding: 0 0 0 6px;
    border-left: 6px solid #406cdd;
  }
  .cont_service {
    width: $themeMinWidth;
    margin: 0 auto;
    .s_main {
      display: flex;
      justify-content: space-between;
      padding: 30px 0 0 0;
      .m_left {
        width: 563px;
        height: 164px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .m_right {
        width: 580px;
        .m_title {
          .title_zh {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }
          .title_en {
            font-size: 16px;
            color: #999999;
            line-height: 24px;
          }
        }
        .serviceList {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .s_item {
            font-size: 16px;
            color: #333333;
            padding: 0 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #ffffff;
            border: solid 1px #e5e5e5;
            margin: 25px 40px 0 0;
          }
        }
      }
    }
  }
  .cont_case {
    padding: 30px 0 0 0;
    .cont_title {
      width: $themeMinWidth;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .c_main {
      background: url("../../assets/img/index/cont_Company.png") center
        no-repeat;
      background-size: cover;
      margin: 30px 0 0 0;
      .m_info {
        width: $themeMinWidth;
        margin: 0 auto;
        padding: 20px 0;
        p {
          // text-indent: 32px;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          text-align: justify;
        }
        .caseBox {
          display: flex;
          flex-wrap: wrap;
          padding: 30px 0 0 0;
          .item_case {
            width: 275px;
            height: 160px;
            background-color: #ffffff;
            box-shadow: 2px 3px 21px 0px rgba(22, 22, 22, 0.05);
            border-radius: 10px;
            margin: 0 60px 20px 0;
            .case_img {
              height: 86px;
              padding: 26px 0 0 0;
              img {
                display: block;
                width: 60px;
                height: 60px;
                object-fit: contain;
                margin: 0 auto;
              }
            }
            p {
              font-size: 16px;
              line-height: 26px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
